import axios from "axios";
import {
	ITEM_FETCH,
	ITEM_CREATE,
	ITEM_UPDATE,
	ITEM_DELETE,
} from "./actionTypes";

function itemFetch(allItem) {
	return {
		type: ITEM_FETCH,
		payload: { allItem },
	};
}

function itemCreate(newItemArray) {
	return {
		type: ITEM_CREATE,
		payload: { newItemArray },
	};
}

function itemUpdate(newItemArray) {
	return {
		type: ITEM_UPDATE,
		payload: { newItemArray },
	};
}

function itemDelete(newItemArray) {
	return {
		type: ITEM_DELETE,
		payload: { newItemArray },
	};
}

export function itemGetApi() {
	return dispatch => {
		axios
			.get("/api/items/")
			.then(res => dispatch(itemFetch(res.data)))
			.catch(err => console.log(err));
	};
}

export function itemPostApi(newItem) {
	return (dispatch, getState) => {
		const items = getState().item;

		if (!newItem.name || !newItem.price) return console.log("Missing Field");

		axios
			.post("/api/items/", newItem)
			.then(res => {
				const newItemArray = [...items, res.data];
				dispatch(itemCreate(newItemArray));
			})
			.catch(err => console.log(err));
	};
}

export function itemPutApi(updateItem) {
	return (dispatch, getState) => {
		const items = getState().item;

		if (
			!updateItem._id ||
			!updateItem.updItem.name ||
			!updateItem.updItem.price
		)
			return console.log("Missing field");

		axios
			.put("/api/items/", updateItem)
			.then(res => {
				const item = items.find(item => item._id === updateItem._id);
				const index = items.indexOf(item);
				items[index].name = updateItem.updItem.name;
				items[index].price = updateItem.updItem.price;
				const newItemArray = [...items];
				dispatch(itemUpdate(newItemArray));
			})
			.catch(err => console.log(err));
	};
}
export function itemDeleteApi(removeItem) {
	return (dispatch, getState) => {
		const items = getState().item;

		if (!removeItem._id) return console.log(removeItem._id);
		axios
			.delete(`/api/items/${removeItem._id}`)
			.then(res => {
				console.log(res.data);
				console.log(items, "1");
				const newItemArray = items.filter(item => item._id !== removeItem._id);
				console.log(newItemArray, "2");
				dispatch(itemDelete(newItemArray));
			})
			.catch(err => console.log(err));
	};
}
